export default __webpack_public_path__ + "static/media/timbre-comprobante.d544aef2.svg";